import { useEffect } from 'react';

const BotNotifier = () => {
 useEffect(() => {
  const hasVisited = localStorage.getItem('visited');
  if (hasVisited) return;

  const sendVisitorInfo = async () => {
    try {
      const res = await fetch('https://ipapi.co/json/');
      const data = await res.json();

      const text = `
      🌐 Yangi foydalanuvchi saytga kirdi!

      IP: ${data.ip}
      Davlat: ${data.country_name}
      Shahar: ${data.city}
      Provider: ${data.org}
      Vaqt: ${new Date().toLocaleString()}
      `;

      await fetch(`https://telegrambroadcast.onrender.com/send`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ text, parse_mode: 'HTML' })
      });

      // Faqat 1 marta jo'natilganini belgilash
      localStorage.setItem('visited', 'true');

    } catch (error) {
      console.error('Xatolik:', error);
    }
  };

  sendVisitorInfo();
}, []);


  return null;
};

export default BotNotifier;